import {formatTimestamp} from "../../../utils/TableTimestamps.tsx";
import {DataTableColumn} from "mantine-datatable";
import {NavLink, useParams} from "react-router-dom";
import {Step} from "../types.ts";
import {I18n} from "@aws-amplify/core";


export const useStepsTableColumns = () => {

    const {id: playbookId, phaseId} = useParams();

    const columns: DataTableColumn<Step>[] = [
        {
            accessor: 'position',
            title: I18n.get('Position'),
            width: 80,
            render: (item: Step) => item.position,
        },
        {
            accessor: 'name',
            title: I18n.get('Name'),
            width: '1fr',
            render: (item: Step) => (
                <NavLink
                    to={`/playbooks/${playbookId ?? item.playbookId}/phases/${phaseId ?? item.phaseId}/steps/${item.id}`}
                >
                    {item.displayName || item.name}
                </NavLink>
            ),
        },
        {
            accessor: 'taskStateName',
            title: I18n.get('Task State'),
            width: '1fr',
            render: (item: Step) => item.taskStateName ?? '',
        },
        {
            accessor: 'targetService',
            title: I18n.get('Target Service'),
            width: '1fr',
            render: (item: Step) => item.targetService ?? '',
        },
        {
            accessor: 'created',
            title: I18n.get('Created'),
            width: '1fr',
            render: (item: Step) => formatTimestamp(item.created),
        },
    ];


    return {
        columns,
    };
};
